import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRoute } from "types";

type InitialState = { data?: IRoute };

const initialState: InitialState = { data: undefined };

const slice = createSlice({
  name: "route-response",
  initialState: initialState,
  reducers: {
    setRouteResponse: (state, action: PayloadAction<IRoute | undefined>) => {
      state.data = action.payload;
    },
    resetRouteResponse: (state) => {
      state.data = undefined;
    },
  },
});

export const {
  reducer,
  actions: { setRouteResponse, resetRouteResponse },
} = slice;
